import { styled } from "styled-components";

export const BuyContainer = styled.div`
  width: 100%;
  height: 100px;
  padding: 8px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;
